import { useForm } from "react-hook-form"
import { ClientesCesantesDTO, ModificarCesanteDTO } from "../models/clientesCesantes"
import { useEffect } from "react"
import { getCliente } from "../service/serviceCesante"
import { StatusCode } from "../../../../utils/enums"
import { useToast } from "../../../../hooks/useToast"
import { Dialog, DialogContent, DialogTitle, Grid2 } from "@mui/material"
import InputText from "../../../../components/inputs/yup/materialui/inputText"
import InputFecha from "../../../../components/inputs/yup/materialui/inputFecha"
import MButton from "../../../../components/inputs/yup/materialui/mButton"
import InputRut from "../../../../components/inputs/yup/materialui/inputRut"
import { useCesante } from "../hooks/useCesante"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup";
import { getCurrentUsername } from '../../../../services/userRolesService';



interface IProps {
    show: boolean
    datosEditar: ClientesCesantesDTO | undefined
    onHide: () => void
    refresh: () => void
}

const schema = yup.object({
    mutuoId: yup.number().required(),
    numeroOperacion: yup.string().required("N° Operación es requerido"),
    omd: yup.string().required("OMD es requerido"),
    fechaInicio: yup.date().notRequired(),
    fechaTermino: yup
        .date()
        .notRequired()
        .max(new Date(), "La fecha de término no puede ser mayor a la fecha actual"),
    fechaFiniquito: yup.date().required("Fecha finiquito es requerida"),
    fechaUltimodificacion: yup.date().notRequired(),
    detalle: yup.string().notRequired(),
    usuario: yup.string().required(),
    rut: yup.string().required(),
});

const ModalCesante: React.FC<IProps> = ({ show, datosEditar, onHide, refresh }) => {
    const { addToast } = useToast();
    const { save } = useCesante();

    const {
        formState: { errors },
        handleSubmit,
        reset,
        setValue,
        control,
        watch,
    } = useForm<ClientesCesantesDTO>({
        mode: 'onBlur',
        resolver: yupResolver(schema),

    })
    const dataForm = watch();
    useEffect(() => {
        if (datosEditar && show) {
            const cargarDatos = async () => {
                const response = await getCliente(datosEditar!.numeroOperacion);
                if (response.status === StatusCode.Ok) {
                    const data = response.data;
                    setValue('mutuoId', data.mutuoId);
                    setValue('rut', data.rut);
                    setValue('omd', data.omd);
                    setValue('fechaInicio', data.fechaInicio);
                    setValue('usuario', data.usuario);
                    setValue('fechaUltimodificacion', data.fechaUltimaModificacion);
                    setValue('fechaTermino', data.fechaTermino);
                    setValue('fechaFiniquito', data.fechaFiniquito);
                    setValue('numeroOperacion', data.numeroOperacion);
                    setValue('detalle', data.detalle);
                }
            };
            cargarDatos();
        } else {
            reset();
            setValue('fechaInicio', new Date)
        }
    }, [datosEditar, show, setValue, reset, addToast]);

    const onSubmit = async (data: ClientesCesantesDTO) => {
        let modificarCesante: ModificarCesanteDTO | undefined = undefined;
        if (datosEditar) {
            modificarCesante = {
                numeroOperacion: datosEditar.numeroOperacion,
                detalle: data.detalle ?? datosEditar.detalle ?? "",
                fechaTermino: data.fechaTermino ?? datosEditar.fechaTermino ?? new Date(),
                fechaFiniquito: data.fechaFiniquito ?? datosEditar.fechaFiniquito ?? new Date(),
                fechaInicio: data.fechaInicio ?? datosEditar.fechaInicio ?? new Date(),
                login: getCurrentUsername(),
            };
        }
        const response = await save(data, modificarCesante);
        if (response.status === StatusCode.NoContent) {

            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: datosEditar ?
                    'Cesante modificado con exito.'
                    : 'Cesante ingresado con exito.'
            });
          customOnHide();
        }
    }


    function customOnHide() {
        reset()
        onHide()
        refresh()
    }

    const numeroOperacion = watch("numeroOperacion");

    useEffect(() => {
        handleNuevoCesante(numeroOperacion);
    }, [numeroOperacion]);


    const handleNuevoCesante = async (value: string | null) => {
        if (value) {
            const resp = await getCliente(value)
            if (resp.status === StatusCode.Ok) {
                const data = resp.data;
                setValue('omd', data.omd);
                setValue('rut', data.rut);
                setValue('mutuoId', data.mutuoId);
                setValue('usuario', data.usuario);
                setValue('fechaInicio', data.fechaInicio ?? new Date());
                setValue('fechaUltimodificacion', data.fechaUltimodificacion ?? new Date());
                setValue('fechaTermino', data.fechaTermino ?? null);
                setValue('detalle', data.detalle ?? "");
            }
        }
    }
    return (
        <Dialog
            open={show}
            onClose={customOnHide}
            maxWidth='lg'
        >
            <DialogTitle>
                {datosEditar ? 'Modificar cesante' : 'Ingresar cesante'}
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid2 container spacing={2}>
                        <Grid2 size={3}>
                            <InputText
                                name="numeroOperacion"
                                control={control}
                                label="N° operación"
                                desabilitado={datosEditar ? true : false}
                                error={errors.numeroOperacion}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="omd"
                                control={control}
                                label="OMD"
                                desabilitado={true}
                                error={errors.omd}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputRut
                                name="rut"
                                control={control}
                                label='RUT'
                                disabled={true}
                            />
                        </Grid2>


                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaInicio"
                                control={control}
                                label="Fecha inicio"
                                disabled={!datosEditar}
                                fecha={dataForm.fechaInicio}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaTermino"
                                control={control}
                                label="Fecha término"
                                disabled={!datosEditar}
                                error={errors.fechaTermino}
                                fecha={dataForm.fechaTermino}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="detalle"
                                control={control}
                                label="Detalle"
                                desabilitado={!datosEditar}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaFiniquito"
                                control={control}
                                label="Fecha finiquito"
                                error={errors.fechaFiniquito}
                                fecha={dataForm.fechaFiniquito}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputText
                                name="usuario"
                                control={control}
                                label="Usuario"
                                desabilitado={true}
                            />
                        </Grid2>
                        <Grid2 size={3}>
                            <InputFecha
                                name="fechaUltimodificacion"
                                control={control}
                                label="Fecha ultima modificación"
                                disabled={true}
                            />
                        </Grid2>
                    </Grid2>
                    <Grid2 container spacing={1} marginTop={2} justifyContent={"flex-end"}>
                        <Grid2>
                            <MButton variant="contained" type="submit" onClick={handleSubmit(onSubmit)}>Guardar</MButton>
                        </Grid2>
                        <Grid2>
                            <MButton variant="contained" color="inherit" onClick={customOnHide}>Cancelar</MButton>
                        </Grid2>
                    </Grid2>
                </form>

            </DialogContent>
        </Dialog>
    )


}

export default ModalCesante;